import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueWechatTitle from 'vue-wechat-title'
import VueClipboard from 'vue-clipboard2'

import 'element-ui/lib/theme-chalk/index.css'
import 'styles/base/base.css'
import smart from 'address-smart-parse'

const configList = {
  'localhost:8080': '1522401346316275712',
  'yc.haolidaifa.com': '1522401346316275712',
  'yc.daoyizx.top': '1522401346316275712',
  'yc1.daoyizx.top': '1522401346316275712',
  'yc1.xiaohuangf.top': '1522401346316275712',
  'yc.shjkk1323.com': '1522401346316275712',
  'yc.xlpdaifa168.com': '1522401346316275712',
  'yc1.xlpdaifa168.com': '1522401346316275712',
  'yc.daifaliwu.cn': '1522401346316275712',
  'yclp.xlpdaifa168.com': '1522401346316275712'
}

Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.prototype.$url = window.location.host === 'yc.haolidaifa.com' ? 'http://yapi.haolidaifa.com' : 'http://ds.273xxs.com'
Vue.prototype.$configList = configList
Vue.prototype.mywindow = window
Vue.prototype.smart = smart
Vue.use(ElementUI)
Vue.use(VueClipboard)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
